/* src/app/pages/user-admin/user-admin.component.scss */
.full-width {
  width: 100%;
}
.user-form {
  display: flex;
  flex-direction: column;
  min-width: 400px;
}
.matwidth {
  width: 300px;
}
table {
  width: 100%;
}
.text-success {
  color: #28a745;
}
.text-danger {
  color: #dc3545;
}
.text-warning {
  color: #ffc107;
}
/*# sourceMappingURL=user-admin.component.css.map */
